module.exports = __webpack_public_path__ + "static/media/gitHubLogo.0b819d63.svg";